export default __webpack_public_path__ + "images/d15d985e45508e238c38b7baedd86541-baseball_small.webp";